module.exports = __webpack_public_path__ + "img/congeladas2.242456c8.jpeg";